export const PARTY = {
  D: { name: "Democrats", short: "Dem", solid: "#0044C9", tint: "#7FA2EC", logo: "/midterms/dem-d.png" },
  R: { name: "Republicans", short: "Rep", solid: "#E81B23", tint: "#F29599", logo: "/midterms/gop-disc.png" },
  I: { name: "Independent", short: "Ind", solid: "#7A5BC4", tint: "#BBA9E3", logo: null },
};

export const STATUS_LABEL = {
  called: "Called",
  projected: "Projected",
  leaning: "Leaning",
  leading: "Leading",
  none: "Awaiting results",
};

export const STATE_NAMES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
  KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
  MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
};

export const NAME_TO_CODE = Object.fromEntries(Object.entries(STATE_NAMES).map(([c, n]) => [n, c]));

export const LAYERS = [
  { id: "senate", label: "Senate" },
  { id: "house", label: "House" },
  { id: "governor", label: "Governors" },
];

export function stateFill(entry) {
  if (!entry) return "rgba(255,255,255,0.05)";
  const p = PARTY[entry.party];
  if (!p) return "rgba(255,255,255,0.22)";
  if (entry.status === "called" || entry.status === "projected") return p.solid;
  return p.tint;
}

export function fmtVotes(n) {
  return Number(n || 0).toLocaleString("en-US");
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}
